export default __webpack_public_path__ + "static/media/weather.fb8b4ce5.png";